import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { ImportPlacesFromAnotherGroupUseCaseInterface } from 'domain/usecases';

export class RemoteImportPlacesFromAnotherGroup
  implements ImportPlacesFromAnotherGroupUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<ImportPlacesFromAnotherGroupUseCaseInterface.Result>,
  ) {}

  async execute(
    params: ImportPlacesFromAnotherGroupUseCaseInterface.Params,
  ): Promise<ImportPlacesFromAnotherGroupUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'post',
      url: this.url,
      body: params,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.created:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
